import React, { useEffect, useRef, useState } from 'react'
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import { HTTP } from '../../../../api/resources';

export default function FilterModal({title, filter, users, filters, active, custom_fields, user = null, pageID = null, team}) {
    const [menuItems, setMenuItems] = useState([])
    const [currentMenu, setCurrentMenu] = useState(null)
    const [filterHolder, setFilterHolder] = useState(filter)
    const [filtersHolder, setFiltersHolders] = useState(filters ? filters : [])
    const [orderOptions, setOrderOptions] = useState([])
    const [saving, setSaving] = useState(false)
    const [fallbackMenu, setFallBackMenu] = useState(null)
    let menu = ''
    

    useEffect(() => {
        if (filter.source_page !== 'public_page') {
            setMenuItems((menuItems) => [...menuItems, {id: 'saved-filters', menu: 'Open Saved Filters'}])
        }

        if (custom_fields && custom_fields.length > 0) {
            custom_fields.map(field => {
                setMenuItems((menuItems) => [...menuItems, {
                    id: field.id,
                    menu: field.name
                }])

                setOrderOptions((orderOptions) => [...orderOptions, {
                    id: String(field.system_key && field.system_key.length > 0 ? field.system_key : field.id), 
                    name: field.name, 
                    system_key: field.system_key && field.system_key.length > 0 ? field.system_key : null,
                }])
            })

            menu = custom_fields[0].id
        }

        if (filter.source_page !== 'public_page') {
            setMenuItems((menuItems) => [...menuItems, {
                id: 'created-date',
                menu: 'Created Date'
            }])

            
        } 
        
        setOrderOptions((orderOptions) => [...orderOptions, {
            id: 'created-date',
            name: 'Created Date',
            system_key: null
        }])

        setMenuItems((menuItems) => [...menuItems, {
            id: 'order',
            menu: 'Order'
        }])

        if (!menu || menu.length < 1) {
            menu = 'order'
        }


        // Adding missing fields 
        // add missing settings 
        setFilterHolder((prev) => {
            return {
                ...prev,
                settings: custom_fields.map(cuField => {
                    if (!prev.settings.find(setting => setting.record_id == cuField.id)) {
                        return {
                            record_id: cuField.id,
                            name: cuField.name,
                            in_custom_field: filterHolder.source_page == 'user_page' ? false : true,
                            system_key: cuField.system_key,
                            value_type: cuField.value_type,
                            record_type: cuField.record_type,
                            value: '',
                            start_date: '',
                            end_date: '',
                            select_values: []
                        }
                    }

                    if (prev.settings.find(setting => setting.record_id == cuField.id)) {
                        return prev.settings.find(setting => setting.record_id == cuField.id)
                    }
                })
            }
        })

        // set default current menu 
        setCurrentMenu((currentMenu) => menu)
        setFallBackMenu((fallbackMenu) => menu)
    }, [])

    const clearFilter = () => {
        setSaving(true)

        HTTP.delete(`/filters/clear_session?source_page=${filterHolder.source_page}&page_id=${pageID}`)
        .then(response => {
            Alert.show('notice', 'Cleared filter, reloading page...')
            setTimeout(() => window.location = response.data, 2000)
        }).catch(e => {
            Alert.show('error', 'Unable to clear filters, please try again later')
            setSaving(false)
        })
    }

    const sendFilter = () => {
        setSaving(true)

        HTTP.post(`/filters/set_session`, {
            filter: filterHolder
        }).then(response => {
            window.location.reload()
        }).catch(e => {
            Alert.show('error', 'Unable to initiate the filter process, please try again later')
            setSaving(false)
        })
    }

    const saveFilter = () => {
        if (!filterHolder.name || filterHolder.name.length < 1) {
            Alert.show('error', 'Name must be present to save the filter')
            return 
        }

        setSaving(true)

        HTTP.post(`/filters`, {
            filter: filterHolder,
            user_id: user.id
        }).then(response => {
            setSaving(false)
            setFiltersHolders(response.data)
            Alert.show('notice', 'Filter saved successfully')
            setCurrentMenu('saved-filters')
            setFilterHolder({...filterHolder, name: ''})
        }).catch(e => {
            setSaving(false)
            Alert.show('error', 'Unable to save filter, please try again later')
        })
    }

    const removeFilter = (savedFilter) => {
        setSaving(true)

        HTTP.delete(`/filters/${savedFilter.id}?user_id=${savedFilter.user_id}`)
        .then(response => {
            setFiltersHolders(response.data)
            setSaving(false)
            Alert.show('notice', 'Filter deleted successfully')
        }).catch(e => {
            setSaving(false)
            Alert.show('error', 'Unable to delete filter, please try again later')
        })
    }

    const useFilter = (savedFilter) => {
        // check to ensure all settings that are not part of the custom fields are removed 
        setFilterHolder({
            name: '',
            record_type: savedFilter.record_type,
            source_page: savedFilter.source_page,
            order: savedFilter.order,
            created_start_date: savedFilter.created_start_date,
            created_end_date: savedFilter.created_end_date,
            settings: savedFilter.settings && savedFilter.settings.length > 0 ? savedFilter.settings.map(setting => {
                if (custom_fields.find(field => field.id == setting.record_id)) {
                    return setting
                }
            }) : [],
            order_by: savedFilter.order_by && savedFilter.order_by.length > 0 && orderOptions.find(option => option.id === savedFilter.order_by) ? savedFilter.order_by : 'created-date',
            order_type: savedFilter.order_type 
        })

        // add missing settings 
        setFilterHolder((prev) => {
            return {
                ...prev,
                settings: custom_fields.map(cuField => {
                    if (!prev.settings.find(setting => setting.record_id == cuField.id)) {
                        return {
                            record_id: cuField.id,
                            name: cuField.name,
                            in_custom_field: filterHolder.source_page == 'user_page' ? false : true,
                            system_key: cuField.system_key,
                            value_type: cuField.value_type,
                            record_type: cuField.record_type,
                            value: '',
                            start_date: '',
                            end_date: '',
                            select_values: []
                        }
                    }

                    if (prev.settings.find(setting => setting.record_id == cuField.id)) {
                        return prev.settings.find(setting => setting.record_id == cuField.id)
                    }
                })
            }
        })

        Alert.show('notice', `${savedFilter.name} has been applied`)
    }

    const updateSetting = (id, value, date_position = false, selectField = false) => {
        if (!id) return false 
        let setting = filterSetting(id)

        if (selectField) {
            setFilterHolder((prev) => {
                return {...prev, settings: prev.settings.map(obj => obj.record_id == id ? {
                    ...obj, 
                    select_values: value.map(val => val.name)
                } : obj)}
            })
            return
        }

        if (isText(setting)) {
            setFilterHolder((prev) => {
                return {...prev, settings: prev.settings.map(obj => obj.record_id == id ? {...obj, value: value} : obj)}
            })
            return
        }

        if (setting.value_type == 'date' && !date_position) {
            setFilterHolder((prev) => {
                return {...prev, settings: prev.settings.map(obj => obj.record_id == id ? {...obj, value: value} : obj)}
            })
            return
        }

        if (setting.value_type == 'date' && date_position && date_position == 'start_date') {
            setFilterHolder((prev) => {
                return {...prev, settings: prev.settings.map(obj => obj.record_id == id ? {...obj, start_date: value} : obj)}
            })
            return
        }

        if (setting.value_type == 'date' && date_position && date_position == 'end_date') {
            setFilterHolder((prev) => {
                return {...prev, settings: prev.settings.map(obj => obj.record_id == id ? {...obj, end_date: value} : obj)}
            })
        }
    }

    const filterSetting = (id) => {
        if (!id) return false 
        if (id === 'created-date' || id === 'saved-filters' || id == 'order') return false

        let cuField = filterField(id)
        if (!cuField) return false 

        let setting = filterHolder.settings.find(s => s.record_id === cuField.id)
        if (setting) return setting

        return false
    }

    const filterField = (id) => {
        if (!id) return false 
        if (id == 'created-date' || id == 'saved-filters' || id == 'order') return false

        let cufield = custom_fields.find(field => field.id == id)
        if (!cufield) return false 
        return cufield
    }

    const isText = (setting) => {
        if (!setting) return false
        let value_type = setting.value_type
        
        if (value_type == 'text' || value_type == 'long_text' || value_type == 'link' || value_type == 'dynamic') return true 
        return false
    }

    const recommendValues = (setting) => {
        if (!users || users.length < 1) return []

        if (isText(setting)) {
            const lowercasedValue = setting.value.toLowerCase();
            let system_key = setting.system_key
            let record_id = setting.record_id

            if (setting.system_key) {
                let validUsers = users.filter(obj => {
                    const propertyValue = String(obj[system_key] || '').toLowerCase()
                    return propertyValue && propertyValue.includes(lowercasedValue);
                }).slice(0, 10)

                // Extract the values of the specific property
                const propertyValues = validUsers.map(obj => obj[system_key]);
                return propertyValues
            }

            if (!setting.system_key && setting.record_id) {
                let validUsers = users.filter(user => {
                    const customField = user.custom_fields_with_meta.find(field => field.team_custom_field_id === record_id);
                    
                    // Check if customField is present and has a non-empty value
                    return customField && customField.value && String(customField.value).toLowerCase().includes(lowercasedValue);
                })
                .slice(0, 10);

                let values = validUsers.map(user => user.custom_fields_with_meta.find(field => field.team_custom_field_id === record_id).value);
                return values
            }
        }

        return []
    }

    const truncateText = (text, maxLength = 100) => {
        return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    }

    const currentFilters = () => {
        // structured in {id, name, value}
        let array = []

        // Fields
        filterHolder.settings.map(setting => {
            if (isText(setting) && setting.value && setting.value.length > 0) {
                array.push({id: setting.id, name: setting.name, value: setting.value})
            }

            if (setting.value_type == 'date' && setting.system_key == 'birthday' && filterHolder.source_page == 'public_page' && setting.value && setting.value.length > 0) {
                array.push({id: setting.id, name: setting.name, value: setting.value})
            }

            if (setting.value_type == 'date' && (filterHolder.source_page !== 'public_page' || setting.system_key !== 'birthday') && (setting.start_date || setting.end_date)) {
                array.push({
                    id: setting.id, 
                    name: setting.name,
                    value: `${setting.start_date && setting.start_date.length > 0 ? setting.start_date : 'Past'}   /  ${setting.end_date && setting.end_date.length > 0 ? setting.end_date : 'Today'}`
                })
            }

            if (setting.value_type == 'select' && setting.select_values && setting.select_values.length > 0) {
                array.push({
                    id: setting.id,
                    name: setting.name,
                    value: setting.select_values.join(', ')
                })
            }
        })

        // Created Date
        if (filterHolder.source_page !== 'public_page' && (filterHolder.created_start_date || filterHolder.created_end_date)) {
            array.push({
                id: 'created-date',
                name: 'Created Date',
                value: `${
                    filterHolder.created_start_date && filterHolder.created_start_date.length > 0 ? filterHolder.created_start_date : 'Past'
                }   /   ${
                    filterHolder.created_end_date && filterHolder.created_end_date.length > 0 ? filterHolder.created_end_date : 'Today'}`
            })
        }

        let orderBy = filterHolder.order_by && filterHolder.order_by.length > 0 && orderOptions.find(op => op.id == filterHolder.order_by) ? orderOptions.find(op => op.id == filterHolder.order_by).name : 'Created Date'
        // Order 
        array.push({
            id: 'order',
            name: 'Order',
            value: `By: ${orderBy}, Order: ${filterHolder.order}`
        })

        return array ? array : []
    }

  return (
    <div>
        <div className='filter-modal-design'>
            <div className="d-flex flex-column shadow mb-5 bg-white rounded d-flex align-items-center justify-content-center my-auto position-relative w-100">
                <button id="x-button" type="button" className='cancel-button-filter'>
                    <span >&times;</span>
                </button>

                <div className='w-100'>
                    <div className='d-flex'>
                        <div className='menu-items-modal'>
                            <ul className='sub-menu-items list-group list-group-flush'>
                                {menuItems && menuItems.map(item => (
                                    <li key={item.id} className={currentMenu == item.id ? 'item active-item list-group-item menu-items-cu' : 'item list-group-item menu-items-cu'} onClick={() => setCurrentMenu(item.id)}>
                                        <div className='list-group-item-body'>
                                            <div className='list-group-item-body-main'>
                                                {item.menu}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className='menu-view'>
                            <div className='sub-menu-view'>
                                {/* Saved Filters */}
                                {currentMenu == 'saved-filters' && (!filtersHolder || filtersHolder.length < 1) && 
                                    <div className='form-group'>
                                        <p>No saved filters. Click the filter dropdown and select Save to create one.</p>
                                    </div>
                                }

                                {currentMenu == 'saved-filters' && filtersHolder && filtersHolder.length > 0 && 
                                    <div className='form-group'>
                                        <ul className='list-group list-group-flush'>
                                            {filtersHolder && filtersHolder.map(item => (
                                                <li key={item.id} className='item list-group-item'>
                                                    <div className='list-group-item-body'>
                                                        <div 
                                                            className='list-group-item-body-main d-flex'
                                                            style={{justifyContent: 'space-between'}}
                                                        >
                                                            <span>{item.name}</span>
                                                            <div className='list-group-item-actions'>
                                                                <button 
                                                                    className='btn btn-primary btn-sm'
                                                                    onClick={() => useFilter(item)}
                                                                    disabled={saving}
                                                                >
                                                                    Use
                                                                </button>
                                                                <button
                                                                    type='button' 
                                                                    className='btn btn-icon' 
                                                                    style={{border: 'none'}}
                                                                >
                                                                <i 
                                                                    className='fa fa-trash text-danger'
                                                                    style={{fontSize: '1.2rem'}}
                                                                    onClick={() => removeFilter(item)} 
                                                                    disabled={saving}
                                                                >
                                                                </i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                }

                                {/* Current Filters */}
                                {currentMenu !== 'saved-filters' && 
                                    <div className='form-group'>
                                        <label>Current Filters</label>
                                        <ul className='sub-menu-items list-group list-group-flush'>
                                            {currentFilters().map(item => (
                                                <li key={item.id} className='item list-group-item'>
                                                    <div className='list-group-item-body'>
                                                        <div 
                                                            className='list-group-item-body-main d-flex'
                                                            style={{justifyContent: 'space-between'}}
                                                        >
                                                            <span>{item.name}: <i style={{fontWeight: 'normal'}}>{item.value}</i></span>
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                }

                                {/* Text fields */}
                                {currentMenu !== 'created-date' && currentMenu !== 'saved-filters' && filterSetting(currentMenu) && 
                                    isText(filterSetting(currentMenu)) &&
                                    <div>
                                        <div className="form-group">
                                            <label htmlFor="title">{filterSetting(currentMenu).name}</label>
                                            <input className="form-control" placeholder="Enter value for recommendations" type="text" name="title" id="title"
                                                value={filterSetting(currentMenu).value}
                                                onChange={e => {
                                                    updateSetting(currentMenu, e.target.value)
                                                }}
                                            />
                                            {filterSetting(currentMenu).value_type == 'dynamic' &&
                                                <small>Enter value in this format "Text (YYYY-MM-DD)", you can also just enter the date or text only</small>
                                            }

                                            <div style={{marginTop: '30px'}}>
                                                <label htmlFor='recommendation'>Recommendations</label>
                                                <ul className='list-group list-group-flush recommended-container-cu'>
                                                    {recommendValues(filterSetting(currentMenu)) && recommendValues(filterSetting(currentMenu)).length > 0 &&
                                                    recommendValues(filterSetting(currentMenu)).map((recommend, index) => (
                                                        <li key={`${recommend}-${index}`}className='item list-group-item cu-recomended-list-capybara'>
                                                            <div className='list-group-item-body'>
                                                                <div 
                                                                    className='list-group-item-body-main d-flex'
                                                                    style={{justifyContent: 'space-between'}}
                                                                >
                                                                    <span>{truncateText(recommend)}</span>
                                                                    <div className='list-group-item-actions'>
                                                                        <button 
                                                                            className='btn btn-primary btn-sm'
                                                                            onClick={() => updateSetting(currentMenu, recommend)}
                                                                        >
                                                                            Use
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {/* Select Fields */}
                                {currentMenu !== 'created-date' && currentMenu !== 'saved-filters' && filterSetting(currentMenu) && 
                                    filterSetting(currentMenu).value_type == 'select' && 
                                    <div className='form-group'>
                                        <label>{filterSetting(currentMenu).name}</label>
                                        <div className="input-group" id="manager_role">
                                            <Select
                                                className={`form-control ${filterSetting(currentMenu).id}-field`}
                                                classNamePrefix={`${filterSetting(currentMenu).id}-field`}
                                                onChange={(type) => updateSetting(currentMenu, type, false, true)}
                                                options={filterField(currentMenu).select_options ?
                                                    filterField(currentMenu).select_options.map(text => ({
                                                        id: text,
                                                        name: text
                                                    })) : []
                                                }
                                                getOptionLabel={(option) =>
                                                    `${option.name}`
                                                }
                                                getOptionValue={(type) => type.name}
                                                value={filterSetting(currentMenu).select_values ? 
                                                    filterSetting(currentMenu).select_values.map(text => ({
                                                        id: text,
                                                        name: text
                                                    })) : []
                                                }
                                                isMulti
                                            />
                                        </div>
                                    </div>
                                }

                                {/* Date fields */}
                                {currentMenu !== 'created-date' && currentMenu !== 'saved-filters' && filterSetting(currentMenu) && 
                                    filterSetting(currentMenu).value_type == 'date' && filterHolder.source_page == 'public_page' &&
                                    filterSetting(currentMenu).system_key == 'birthday' && 
                                    <div>
                                        <div className="form-group">
                                            <label htmlFor={`${filterSetting(currentMenu).id}-field`}>{filterSetting(currentMenu).name}</label>
                                            <Flatpickr className="form-control"
                                                value={filterSetting(currentMenu).value}
                                                onChange={(date, dateStr, instance) => {
                                                    updateSetting(currentMenu, dateStr)
                                                }}
                                            />
                                            <small>Only monnth and day is used to filter record for this field</small>
                                        </div>
                                    </div>
                                }
                                

                                {currentMenu !== 'created-date' && currentMenu !== 'saved-filters' && filterSetting(currentMenu) && 
                                    filterSetting(currentMenu).value_type == 'date' && (filterHolder.source_page !== 'public_page' || filterSetting(currentMenu).system_key !== 'birthday') &&
                                    <div>
                                        <div className="form-group">
                                            <label htmlFor={`${filterSetting(currentMenu).id}-field`}>Start Date ( {filterSetting(currentMenu).name} )</label>
                                            <Flatpickr className="form-control"
                                                value={filterSetting(currentMenu).start_date}
                                                onChange={(date, dateStr, instance) => {
                                                    if (filterSetting(currentMenu).end_date && filterSetting(currentMenu).end_date < dateStr) {
                                                        Alert.show('error', 'Start date cannot be higher than end date')
                                                        updateSetting(currentMenu, null, 'start_date')
                                                        instance.input.value = ''
                                                    } else {
                                                        updateSetting(currentMenu, dateStr, 'start_date')
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor={`${filterSetting(currentMenu).id}-field`}>End Date ( {filterSetting(currentMenu).name} )</label>
                                            <Flatpickr className="form-control"
                                                value={filterSetting(currentMenu).end_date}
                                                onChange={(date, dateStr, instance) => {
                                                    if (filterSetting(currentMenu).start_date && filterSetting(currentMenu).start_date > dateStr) {
                                                        Alert.show('error', 'Start date cannot be higher than end date')
                                                        updateSetting(currentMenu, null, 'end_date')
                                                        instance.input.value = ''
                                                    } else {
                                                        updateSetting(currentMenu, dateStr, 'end_date')
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                }

                                {/* Created date */}
                                {currentMenu == 'created-date' && 
                                    <div>
                                        <div className="form-group">
                                            <label htmlFor="start_created_date">Start Date <small>( Created Date )</small></label>
                                            <Flatpickr className="form-control"
                                                value={filterHolder.created_start_date}
                                                onChange={(date, dateStr, instance) => {
                                                    if (filterHolder.created_end_date && filterHolder.created_end_date < dateStr) {
                                                        Alert.show('error', 'Created start date cannot be higher than end date')
                                                        setFilterHolder({...filterHolder, created_start_date: null})
                                                        instance.input.value = ''
                                                    } else {
                                                        setFilterHolder({...filterHolder, created_start_date: dateStr})
                                                    }
                                                }}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="published_on">End Date <small>( Created Date )</small></label>
                                            <Flatpickr className="form-control"
                                                value={filterHolder.created_end_date}
                                                onChange={(date, dateStr, instance) => {
                                                    if (filterHolder.created_start_date && filterHolder.created_start_date > dateStr) {
                                                        Alert.show('error', 'Created start date cannot be higher than end date')
                                                        setFilterHolder((prev) => ({ ...prev, created_end_date: null }));
                                                        instance.input.value = ''
                                                    } else {
                                                        setFilterHolder({...filterHolder, created_end_date: dateStr})
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                }

                                {/* Order */}
                                {currentMenu === 'order' &&
                                    <div>
                                        <div className='form-group'>
                                            <label>Order By</label>
                                            <div className="input-group" id="manager_role">
                                                <Select
                                                    className={`form-control order_by`}
                                                    classNamePrefix={`order_by`}
                                                    onChange={(type) => {
                                                        if (type.system_key && type.system_key.length > 0) {
                                                            setFilterHolder({...filterHolder, order_type: 'system_field', order_by: type.id})
                                                        } else {
                                                            setFilterHolder({...filterHolder, order_type: 'custom_field', order_by: type.id})
                                                        }
                                                    }}
                                                    options={orderOptions}
                                                    getOptionLabel={(option) =>
                                                        `${option.name}`
                                                    }
                                                    getOptionValue={(type) => type.id}
                                                    value={orderOptions.find(option => option.id == filterHolder.order_by)}
                                                />
                                            </div>
                                        </div>
                                        
                                        <div className='form-group'>
                                            <label>Order</label>
                                            <div className="input-group" id="manager_role">
                                                <Select
                                                    className={`form-control order_layout`}
                                                    classNamePrefix={`order_layout`}
                                                    onChange={(type) => setFilterHolder({...filterHolder, order: type.name})}
                                                    options={
                                                        [{id: 'ascending', name: 'Ascending'}, {id: 'descending', name: 'Descending'}]
                                                    }
                                                    getOptionLabel={(option) =>
                                                        `${option.name}`
                                                    }
                                                    getOptionValue={(type) => type.name}
                                                    value={{id: filterHolder.order, name: filterHolder.order}}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }

                                {/* Filter Saver */}
                                {currentMenu === 'save-new-filter' &&
                                    <div className="form-group">
                                        <label htmlFor="title">Filter Name</label>
                                        <input className="form-control" placeholder="Enter Filter Name" type="text" name="title" id="title"
                                            value={filterHolder.name}
                                            onChange={e => {
                                                setFilterHolder({...filterHolder, name: e.target.value})
                                            }}
                                        />
                                    </div>
                                }
                            </div>

                            {currentMenu !== 'save-new-filter' && 
                                <div className="pt-3 filter-buttons mr-3 text-right mt-3 mb-3">
                                    <button onClick={clearFilter} type="button" className="btn btn-danger mr-2" disabled={saving}>
                                        Clear Filter
                                    </button>

                                    <div className="btn-group">
                                        <button onClick={sendFilter} type="button" className={filter.source_page !== 'public_page' ? "btn btn-primary btn-split-left" :  "btn btn-primary"} disabled={saving}>
                                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                            Filter
                                        </button>
                                        {filter.source_page !== 'public_page' && 
                                            <>
                                                <button type="button" className="btn btn-primary btn-narrow dropdown-toggle dropdown-toggle-split btn-split-right btn-narrow-for-filter" data-toggle="dropdown" aria-expanded="false">
                                                    <span className="sr-only">Toggle Dropdown</span>
                                                </button>
                                                <ul className="dropdown-menu dropdown-menu-right">
                                                    <li>
                                                    <button onClick={() => setCurrentMenu('save-new-filter')}
                                                        disabled={saving}
                                                        name="button"
                                                        className="dropdown-item"
                                                        type="button">
                                                        Save Current Filter
                                                    </button>
                                                    </li>
                                                </ul>
                                            </>
                                        }
                                    </div>
                                </div>
                            }

                        {currentMenu == 'save-new-filter' && 
                            <div className="pt-3 filter-buttons mr-3 text-right mt-3 mb-3">
                                <button onClick={() => setCurrentMenu(fallbackMenu)} type="button" className="btn btn-danger mr-2" disabled={saving}>
                                    Cancel
                                </button>

                                {menu}

                                <button onClick={saveFilter} type="button" className="btn btn-primary" disabled={saving}>
                                    {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                                    Confirm Save
                                </button>
                            </div>
                        }
                </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
  )
}